import { render, staticRenderFns } from "./GameRondo.vue?vue&type=template&id=92826072&"
import script from "./GameRondo.vue?vue&type=script&lang=js&"
export * from "./GameRondo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports